module.exports = __webpack_public_path__ + "icon-512x512.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/icon-512x512.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/icon-512x512.png
// module chunks = 35